export const fetchGlobalSections = requestData => {
  return $api('/api/v1/global', {
    method: 'POST',
    body: requestData,
  })
}

export const fetchGlobalConfig = requestData => {
  return $api('/api/v1/service/config', {
    method: 'POST',
    body: requestData,
  })
}
export const downloadKycDocPicUrl = requestData => {
  const params = new URLSearchParams({
    user_id: requestData.user_id ?? '',
    doc_pic_type: requestData.doc_pic_type ?? '',
  })
  return $api(`/api/v1/kyc/doc_pic?${params.toString()}`, {
    method: 'GET',
  })
}